import React from "react";

function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      fill="none"
      viewBox="0 0 14 14"
    >
      <path
        fill="#E6E8EF"
        d="M11.72 1c.288.249.517.455.688.62.17.164.301.303.392.417.09.115.147.212.168.291.021.08.032.15.032.21v.238h-2.368a.397.397 0 01-.28-.112 1 1 0 01-.2-.261 1.36 1.36 0 01-.16-.552V0h.048c.085 0 .173.012.264.037.09.025.195.072.312.142.117.07.264.17.44.299.176.129.397.303.664.522zm-2.736.866c0 .199.032.405.096.62.064.213.165.412.304.596.139.184.315.336.528.455.213.12.464.18.752.18H13v8.417c0 .289-.061.548-.184.776a1.833 1.833 0 01-.488.582c-.203.16-.427.284-.672.374-.245.09-.485.134-.72.134H3.064c-.203 0-.424-.055-.664-.164a2.819 2.819 0 01-.672-.433 2.543 2.543 0 01-.52-.612A1.362 1.362 0 011 12.075V1.925c0-.209.05-.425.152-.649A2.42 2.42 0 012.168.186 1.43 1.43 0 012.872 0h6.112v1.866zm1.008 9.313a.979.979 0 00.704-.276.887.887 0 00.288-.664.864.864 0 00-.288-.657.994.994 0 00-.704-.269h-6a.994.994 0 00-.704.27.864.864 0 00-.288.656c0 .258.096.48.288.664a.979.979 0 00.704.276h6zm.992-4.657a.887.887 0 00-.288-.664.98.98 0 00-.704-.276h-6a.98.98 0 00-.704.276.887.887 0 00-.288.664c0 .26.096.478.288.657.192.18.427.269.704.269h6c.277 0 .512-.09.704-.269a.864.864 0 00.288-.657z"
      ></path>
    </svg>
  );
}

export default Icon;
